// extracted by mini-css-extract-plugin
export default {"insights-container":"Insights_insights-container__zrHmv","insights-content":"Insights_insights-content__Lyj3+"};